<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close transfer>
			<template #default>
				<div ref="task_edit_form"></div>
<!-- 				<vxe-grid ref="list" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid> -->
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [
				{
					"type": "el-divider",
					"children": [
						"基本信息"
					]
				},
				{
					"type": "$input",
					"field": "name",
					"title": "任务名称",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":false
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "type",
					"title": "任务类型",
					"value": "price",
					"hidden": false,
					"options": [{
						"label":"智能出价",
						"value":"price",
					},{
						"label":"推广状态",
						"value":"status",
					}],
					"props": {
						"clearable":false,
						"readonly":false
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "mark",
					"title": "备注",
					"value": null,
					"hidden": false,
					"props": {
						"inputprops":{
							"type":"textarea"
						},
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"field": "推广状态",
					"hidden": true,
					"children": [
						"推广状态"
					]
				},
				{
					"type": "$switchs",
					"field": "status",
					"title": " ",
					"value": null,
					"hidden": true,
					"props": {
						"activeText":"开启",
						"inactiveText":"关闭",
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"field": "出价目标",
					"children": [
						"出价目标"
					]
				},
				{
					"type": "$switchs",
					"field": "constraintValueEnable",
					"title": "是否启用",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "constraintValueType",
					"title": "类型",
					"value": "dir_conv",
					"hidden": false,
					"options": [{
						"label":"平均成交成本",
						"value":"dir_conv",
					},{
						"label":"平均点击成本",
						"value":"click",
					}],
					"props": {
						"clearable":false,
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputNumber",
					"field": "constraintValueAdjust",
					"title": "调整值",
					"value": null,
					"hidden": false,
					"props": {
						"precision":2,
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputNumber",
					"field": "constraintValueLimit",
					"title": "极值",
					"value": null,
					"hidden": false,
					"props": {
						"precision":2,
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "constraintValueDirection",
					"title": "方向",
					"value": "add",
					"hidden": false,
					"options": [{
						"label":"增加",
						"value":"add",
					},{
						"label":"减少",
						"value":"reduce",
					},{
						"label":"还原",
						"value":"reset",
					}],
					"props": {
						"clearable":false,
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "constraintValueAmplitude",
					"title": "幅度",
					"value": "percent",
					"hidden": false,
					"options": [{
						"label":"百分比",
						"value":"percent",
					},{
						"label":"数字",
						"value":"number",
					}],
					"props": {
						"clearable":false,
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "constraintValueReference",
					"title": "参考项",
					"value": "base",
					"hidden": false,
					"options": [{
						"label":"基准值",
						"value":"base",
					},{
						"label":"当前值",
						"value":"current",
					}],
					"props": {
						"clearable":false,
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"field": "每日预算",
					"hidden": false,
					"children": [
						"每日预算"
					]
				},
				{
					"type": "$switchs",
					"field": "dayBudgetEnable",
					"title": "是否启用",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "dayBudgetType",
					"title": "类型",
					"value": "dayBudget",
					"hidden": true,
					"options": [{
						"label":"每日预算",
						"value":"dayBudget",
					}],
					"props": {
						"clearable":false,
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputNumber",
					"field": "dayBudgetAdjust",
					"title": "调整值",
					"value": null,
					"hidden": false,
					"props": {
						"precision":2,
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputNumber",
					"field": "dayBudgetLimit",
					"title": "极值",
					"value": null,
					"hidden": false,
					"props": {
						"precision":2,
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "dayBudgetDirection",
					"title": "方向",
					"value": "add",
					"hidden": false,
					"options": [{
						"label":"增加",
						"value":"add",
					},{
						"label":"减少",
						"value":"reduce",
					},{
						"label":"还原",
						"value":"reset",
					}],
					"props": {
						"clearable":false,
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "dayBudgetAmplitude",
					"title": "幅度",
					"value": "percent",
					"hidden": false,
					"options": [{
						"label":"百分比",
						"value":"percent",
					},{
						"label":"数字",
						"value":"number",
					}],
					"props": {
						"clearable":false,
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "dayBudgetReference",
					"title": "参考项",
					"value": "base",
					"hidden": false,
					"options": [{
						"label":"基准值",
						"value":"base",
					},{
						"label":"当前值",
						"value":"current",
					}],
					"props": {
						"clearable":false,
						"readonly":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				// {
				// 	"type": "$datePicker",
				// 	"field": "time",
				// 	"title": "time",
				// 	"props": {
				// 		"type": "date",
				// 		"disabled":true
				// 	},
				// 	"value": null,
				// 	"hidden": false,
				// 	"validate": [{
				// 		"required": false,
				// 		"message": "必填项"
				// 	}]
				// },
				// {
				// 	"type": "$emun",
				// 	"field": "emun",
				// 	"title": "emun",
				// 	"value": null,
				// 	"hidden": false,
				// 	"props": {
				// 		"name": "enable"
				// 	},
				// 	"validate": [{
				// 		"required": false,
				// 		"message": "必填项"
				// 	}]
				// }
			],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	// import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [modalMixins],
		// mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model:false,
				modal_title: '编辑任务',
				modal_width:600,
				modal_height:700,
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			typeChange(){
				this.statusItemHide()
				this.priceItemHide()
				let type = this.fApi.getValue('type')
				if(type == 'price'){
					this.priceItemShow()
				}else if(type == 'status'){
					this.statusItemShow()
				}else{
					this.statusItemHide()
				}
			},
			priceItemShow(){
				formjson.rule.rule.forEach((item)=>{
					if(item.field){
						if(item.field == '出价目标' || item.field.indexOf('constraintValue')!==-1){
							this.fApi.updateRule(item.field,{hidden:false})
						}
						if(item.field == '每日预算' || item.field.indexOf('dayBudget')!==-1){
							this.fApi.updateRule(item.field,{hidden:false})
						}
					}
				})
			},
			priceItemHide(){
				formjson.rule.rule.forEach((item)=>{
					if(item.field){
						if(item.field == '出价目标' || item.field.indexOf('constraintValue')!==-1){
							this.fApi.updateRule(item.field,{hidden:true})
						}
						if(item.field == '每日预算' || item.field.indexOf('dayBudget')!==-1){
							this.fApi.updateRule(item.field,{hidden:true})
						}
					}
				})
			},
			statusItemShow(){
				this.fApi.updateRule('推广状态',{hidden:false})
				this.fApi.updateRule('status',{hidden:false})
			},
			statusItemHide(){
				this.fApi.updateRule('推广状态',{hidden:true})
				this.fApi.updateRule('status',{hidden:true})
			},
			constraintValueEnableChange(){
				this.createmark()
			},
			dayBudgetEnableChange(){
				this.createmark()
			},
			createmark(){
				let obj = {}
				formjson.rule.rule.forEach((item)=>{
					if(item.field){
						if(item.field.indexOf('constraintValue')!==-1){
							if(!obj['constraintValue']){
								obj['constraintValue'] = []
							}
							obj['constraintValue'].push(this.fApi.getValue(item.field))
							
						}
						if(item.field.indexOf('dayBudget')!==-1){
							if(!obj['dayBudget']){
								obj['dayBudget'] = []
							}
							obj['dayBudget'].push(this.fApi.getValue(item.field))
						}
					}
				})
				let mark = []
				for(let i in obj){
					let str = ''
					let title = ''
					// console.log(obj)
					if(i == 'constraintValue'){
						if(obj[i][1] == 'click'){
							title = '平均点击成本'
						}
						if(obj[i][1] == 'dir_conv'){
							title = '平均成交成本'
						}
					}
					if(i == 'dayBudget'){
						if(obj[i][1] == 'dayBudget'){
							title = '每日预算'
						}
					}
					if(obj[i][0] && obj[i][4] == 'reset'){
						str = title + '【还原】'
						mark.push(str)
						continue
					}

					if(obj[i][0] && parseFloat(obj[i][2]) && obj[i][4] && obj[i][5]){
						str = title +'【' + (obj[i][4] == 'add'?'增加':'减少') + '】' + obj[i][2] + (obj[i][5] == 'percent'?'%':'')
						if(parseFloat(obj[i][3])){
							str = str + '【最' + (obj[i][4] == 'add'?'大':'小') + '值】' + obj[i][3]
						}
						str = str + ' 参考项' + (obj[i][6] == 'base' ? '【基准值】' : '【当前值】')
						mark.push(str)
					}
					
				}
				this.fApi.setValue('mark',mark.join("\n"))
				


				// console.log(obj)
			},
			// list_beforeCreateGrid(gridOptions) {
			// 	gridOptions.height = 550
			// 	gridOptions.toolbarConfig = {
			// 		size: 'mini',
			// 		perfect: false,
			// 		buttons: [{
			// 			name: '新增',
			// 			status: 'primary',
			// 			code: 'add'
			// 		}],
			// 		customConfig: {
			// 			storage: true
			// 		},
			// 		custom: true,
			// 		refresh: true,
			// 		zoom: true,
			// 		tools: []
			// 	}
			// 	gridOptions.columns = [{
			// 			type: 'checkbox',
			// 			title: '#',
			// 			width: 50,
			// 		}, {
			// 			field: 'a',
			// 			title: 'a',
			// 			editRender: {
			// 				name: '$select',
			// 				props: {
			// 					selectoptions:[{
			// 						value:'123',
			// 						label:'123'
			// 					}]
			// 				},
			// 				events: {
								
			// 				}
			// 			},
			// 		}, {
			// 			field: 'b',
			// 			title: 'b',
			
			// 		}, {
			// 			field: 'c',
			// 			title: 'c',
			// 			editRender: {
			// 				name: '$input',
			// 				props: {
			// 					quote: false
			// 				},
			// 				events: {

			// 				}
			// 			},
			// 		},
			// 		{
			// 			title: '操作',
			// 			fixed: "right",
			// 			align: 'center',
			// 			width: 65,
			// 			slots: {
			// 				default: ({row}) => {
			// 					return [<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>]
			// 				}
			// 			}
			// 		}
			// 	]
			// 	gridOptions.formConfig = false
			// 	// gridOptions.editRules = {
			// 	// 	c: [{
			// 	// 		required: true
			// 	// 	},
			// 	// 	{
			// 	// 		validator({cellValue,row}){
			// 	// 			return new Promise((resolve,reject)=>{
			// 	// 				if( true ){
			// 	// 					reject(new Error('自定义错误'))
			// 	// 				}else{
			// 	// 					resolve()
			// 	// 				}
								
			// 	// 			})
			// 	// 		}
			// 	// 	}]
			// 	// }
			// },
			// list() {
			// 	return new Promise((resolve) => {
			// 		resolve({
			// 			list: []
			// 		})
			// 	})
			// },
			modal_init(){
				this.sourceData = this.data.config
				
				let formData = JSON.parse(JSON.stringify(formjson))
				let rule = formData.rule.rule
				let option = formData.rule.option
				option.el = this.$refs.task_edit_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()		
				})
				this.$emit('show')
			},	
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						if(item == 'constraintValueEnable'){
							this.sourceData[item] = this.sourceData[item] == 1 ? 1 : 0
						}
						if(item == 'dayBudgetEnable'){
							this.sourceData[item] = this.sourceData[item] == 1 ? 1 : 0
						}
						if(item == 'status'){
							this.sourceData[item] = this.sourceData[item] == 1 ? 1 : 0
						}
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
				this.typeChange()
			},
			getgrid(){
				return this.$refs.list
			},
			add(){
				this.getgrid().insert({})
			},
			delete(row){
				this.getgrid().remove(row)
			},
			submit() {
				this.createmark()
				this.fApi.submit((formData) => {
					
					let submitData = JSON.parse(JSON.stringify(formData))
					this.submitDataFormater(submitData)
					
					let obj = {}
					obj.config = submitData
					obj.name = submitData.name
					obj.type = submitData.type
					obj.mark = submitData.mark
					if(this.data.id){
						obj.id = this.data.id
					}	
					
					this.$api.campaign.edittask(obj).then(()=>{
						this.$emit('success')
						this.modal_cancel()
					})
					console.log(submitData)
					// this.getgrid().validate(true, (res) => {
					// 	if (!res) {
					// 		let submitData = JSON.parse(JSON.stringify(formData))
					// 		this.submitDataFormater(submitData)
					// 		let detail = this.getgrid().getTableData().visibleData
					// 		let data = {}
					// 		data.main = submitData
					// 		data.costorder_detail = detail
					// 		this.createJson(data)
					// 		//console.log(data,123123)
					// 		this.$emit('success', {
					// 			data: JSON.stringify(data)
					// 		})
					// 		this.modal_cancel()
					// 		console.log(data)
					// 	} else {
							// for (let i in res) {
							// 	console.log(res[i][0].rule)
							// 	let content = res[i][0].rule.$options.content
							// 	let message = res[i][0].rule.$options.message
							// 	if(content){
							// 		this.$message.error(content)
							// 	}else if(message){
							// 		this.$message.error(message)
							// 	}else{
							// 		this.$message.error('缺少必填项：' + res[i][0].column.title)
							// 	}
								
							// }
					// 	}
					// })
				})
				//this.init()
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>